<template>
  <v-card outlined class="mx-auto list-item white-blur">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="text-h6 mb-1">
          <div class="d-flex align-center justify-space-between">
            <div class="list-item-title">
              <v-icon :color="value.color">
                {{ value.icon }}
              </v-icon>
              {{ value.name }}
            </div>

            <div>
              <v-chip label :color="getStatus(value).color" dark>
                {{ getStatus(value).text }}
              </v-chip>
            </div>
          </div>
        </v-list-item-title>
        <v-list-item-subtitle>{{ value.question }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text class="py-0">
      <v-chip-group active-class="primary--text" >
        <v-chip v-for="param in value.Parameters" :key="param.id">
          {{ param.Parameter.name }}
        </v-chip>
      </v-chip-group>
    </v-card-text>

    <v-card-actions class="card-actions-bottom">
      <v-btn outlined text @click="() => $emit('onDetails', value)">
        View Details
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
  
  
<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    getStatus(item) {
      return item.Status
        ? {
            color: item.Status.color,
            text: item.Status.name,
          }
        : {
            color: "grey",
            text: "Unknown",
          };
    },
  },
};
</script>
  
  
  <style lang="scss" scoped>
.list-item {
  overflow: hidden;
  height: 200px;

  .list-item-title {
    max-width: 75%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>